<template>
<!--  &lt;!&ndash; Leaf component with link - render HTML &ndash;&gt;-->
<!--  <NuxtLink-->
<!--    v-if="hasLink() && !hasChild()"-->
<!--    class="ao__text"-->
<!--    v-html="props.payload?.rendered"-->
<!--    :class="[getAlign()]"-->
<!--    :to="props.payload?.attributes?.attrs?.href"-->
<!--    target="_blank"-->
<!--  />-->
  <!-- Nested ArtObjects with link - render child -->
  <NuxtLink
    v-if="hasLink() && hasChild()"
    class="ao__text"
    :class="[getAlign()]"
    :to="props.payload?.attributes?.attrs?.href"
    target="_blank"
  >
    <DefaultArticlesArtObject
      v-for="(content, index) in props.payload?.content"
      :type="content?.type"
      :payload="content"
      :parent-ident="`${props.parentIdent}|text-${index}`"
    />
  </NuxtLink>
  <!-- Nested ArtObjects without link - render child -->
  <span
    v-else-if="!hasLink() && hasChild()"
    class="ao__text"
    :class="[getAlign()]"
  >
    <DefaultArticlesArtObject
      v-for="(content, index) in props.payload?.content"
      :type="content?.type"
      :payload="content"
      :parent-ident="`${props.parentIdent}|text-${index}`"
    />
  </span>
  <!-- Leaf component without link - render HTML -->
  <span
    v-else
    class="ao__text"
    v-html="props.payload?.rendered"
    :class="[getAlign()]"
  />

</template>

<script setup lang="ts">
const props = defineProps({
  type: { type: String, required: true },
  payload: { type: Object, required: false },
  parentIdent: { type: String, required: false },
})

const getAlign = () => {
  switch (props.payload?.attributes?.align) {
    case 'right':
      return 'text-right'
    case 'center':
      return 'text-center';
    default:
      return 'text-left';
  }
}

const hasLink = () => {
  return !!props.payload?.attributes?.attrs?.href
}

const hasChild = () => {
  return !!(props.payload?.content && props.payload?.content.length > 0)
}
</script>

<style lang="scss" scoped>
a {
  @apply inline-block;
}
</style>
